import { ProgressStatus } from '@exam-center/graphql';
import {
  CancelOutlinedIcon,
  CheckCircleOutlineRoundedIcon,
  DoNotDisturbOnOutlinedIcon,
  PendingOutlinedIcon,
} from '@shared/components';

interface ExamineeMonitorStatusIconProps {
  status: ProgressStatus;
}

export default function ExamineeMonitorStatusIcon({
  status,
}: Readonly<ExamineeMonitorStatusIconProps>) {
  switch (status) {
    case ProgressStatus.Completed:
      return (
        <CheckCircleOutlineRoundedIcon
          sx={(theme) => ({
            color: theme.palette.success.main,
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
    case ProgressStatus.Failed:
      return (
        <CancelOutlinedIcon
          sx={(theme) => ({
            color: theme.palette.error.main,
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
    case ProgressStatus.InProgress:
      return (
        <PendingOutlinedIcon
          sx={(theme) => ({
            color: theme.palette.warning.main,
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
    default:
      return (
        <DoNotDisturbOnOutlinedIcon
          sx={(theme) => ({
            color: theme.palette.grey[500],
            fontSize: theme.typography.pxToRem(20),
            alignItems: 'center',
          })}
        />
      );
  }
}
